var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show-slide",rawName:"v-show-slide",value:(_vm.show),expression:"show"}]},[_c('div',{class:[
      ("alert alert-" + _vm.type),
      { 'alert-msg-slim': _vm.slim },
      _vm.outerClass
    ],attrs:{"aria-live":"assertive"}},[_c('div',{class:['d-flex gap-3', _vm.innerClass]},[_c('span',{class:("alert-msg-icon bi bi-" + _vm.iconSubClass)}),_c('div',{staticClass:"alert-msg-body"},[(_vm.title)?_c('h5',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }